import React, { Component } from 'react';

export default class SignUp extends Component {
  render() {
    return (
      <div>
        <h1>报名列表</h1>
      </div>
    );
  }
}
